export default __webpack_public_path__ + "static/media/model-x-mobile.e1bb13a5.jpeg";